import React from "react";
import PropTypes from "prop-types";

// styles
import NotificationBoxStyled from "./NotificationBox.styled";

const NotificationBox = ({ heading, text, borderColor, onClose, ctaText, ctaClick }) => {
    return (
        <NotificationBoxStyled borderColor={borderColor}>
            <div>
                <h3 className="h4">{heading}</h3>
                <button type="button" onClick={onClose} className="closeBn gtm-bannerBusinessClose" aria-label="Close business banner">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <path
                            d="M12.0821 3.33212C12.4727 2.94159 12.4727 2.30843 12.0821 1.9179C11.6916 1.52738 11.0584 1.52738 10.6679 1.9179L12.0821 3.33212ZM1.91792 10.6679C1.5274 11.0584 1.5274 11.6916 1.91792 12.0821C2.30844 12.4726 2.94161 12.4726 3.33213 12.0821L1.91792 10.6679ZM10.6679 12.0821C11.0584 12.4726 11.6916 12.4726 12.0821 12.0821C12.4726 11.6916 12.4726 11.0584 12.0821 10.6679L10.6679 12.0821ZM3.33211 1.91789C2.94158 1.52737 2.30842 1.52737 1.91789 1.91789C1.52737 2.30842 1.52737 2.94158 1.91789 3.33211L3.33211 1.91789ZM10.6679 1.9179L6.29291 6.29291L7.70712 7.70713L12.0821 3.33212L10.6679 1.9179ZM6.29291 6.29291L1.91792 10.6679L3.33213 12.0821L7.70712 7.70713L6.29291 6.29291ZM12.0821 10.6679L7.70712 6.29291L6.29291 7.70713L10.6679 12.0821L12.0821 10.6679ZM7.70712 6.29291L3.33211 1.91789L1.91789 3.33211L6.29291 7.70713L7.70712 6.29291Z"
                            fill="#003D4C"
                        />
                    </svg>
                </button>
            </div>
            <div className="boxContent">
                <p>{text}</p>
                <button type="button" className="gtm-banner bn bn--primary bn--primary-blue" onClick={ctaClick}>
                    {ctaText}
                </button>
            </div>
        </NotificationBoxStyled>
    );
};

export default NotificationBox;

// props validation
NotificationBox.propTypes = {
    heading: PropTypes.string,
    text: PropTypes.string,
    borderColor: PropTypes.string,
    onClose: PropTypes.func,
    ctaText: PropTypes.string,
    ctaClick: PropTypes.func
};
